import Component from './user_list.vue'
export default Component
